import { Breadcrumbs, CommonMultiSelect, CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import ErrorComponent from "components/shared/ErrorComponent";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppProfilePictureField from "components/shared/FormComponents/AppProfilePictureField";
import LoadingButton from "components/shared/LoadingButton";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { Col, Container, Form, Row } from "react-bootstrap";

import styles from './profile.module.scss';
import { Formik } from "formik";
import { CLIENT_TYPES, MIME_TYPES, TIMEZONE_OPTIONS } from "config/constants";
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { cloneDeep, debounce, isEmpty } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { useCheckUsernameMutation, useGetProfileQuery, useUpdateProfileMutation } from "store/services/auth";
import profileSchema from "./profile.schema";
import { EditIcon } from "Assets/icons";
import UpdateEmailPop from "components/Modals/UpdateEmailPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { errorMessageToast, successMessageToast } from "helpers/common";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import rightCheckBlue from "../../../Assets/images/rightCheckBlue.png";
import GreySvgCross from "Assets/images/GreySvgCross";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import AppInputFieldV2 from "components/Common/AppInputFIeldV2";
import FilePicker from "components/Common/FilePicker";
import { Loader } from "react-feather";
import Step3 from "../OnboardV2/Step3";
import UserDocuments from "./UserDocuements";
import TextInputV2 from "components/Common/TextInputV2";

const UserInformation = () => {

    const [showEmailModal, setShowEmailModal] = useState(false);
    const [usernameError, setUsernameError] = useState(null);

    const { data: therapistDetails, isLoading: therapistDetailsLoading, isError: therapistDetailsError, isFetching: therapistDetailsFetching } = useGetProfileQuery();
    const [updateProfile, { isLoading: updateProfileLoading }] = useUpdateProfileMutation();
    const [checkUsername, { isLoading: checkUsernameLoading }] = useCheckUsernameMutation();
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    const initialValues = useMemo(() => {
        console.log("therapistDetails", therapistDetails)

        return {
            profile_picture: therapistDetails?.profile_picture || "",
            firstname: therapistDetails?.firstname || "",
            lastname: therapistDetails?.lastname || "",
            email: therapistDetails?.email || "",
            phone: therapistDetails?.phone || "",
            address1: therapistDetails?.therapist_detail?.address1 || "",
            address2: therapistDetails?.therapist_detail?.address2 || "",
            city: therapistDetails?.therapist_detail?.city || "",
            postal_code: therapistDetails?.therapist_detail?.postal_code || "",
            therapistDocuments: therapistDetails?.therapistDocuments || {
                policy_check: "",
                business_license: "",
                college_registration: "",
                professional_liability_insurance: "",
                professional_liabilities_insurances: []
            }
            ,
            username: therapistDetails?.username || "",
            discipline_id: {
                value: therapistDetails?.therapist_detail?.discipline_id,
                label: therapistDetails?.therapist_detail?.therapist_discipline?.name
            },
            type: therapistDetails?.therapist_detail?.type,
            designation_id: {
                value: therapistDetails?.therapist_detail?.designation_id,
                label: therapistDetails?.therapist_detail?.therapist_designation?.title
            },
            registration_number: therapistDetails?.therapist_detail?.registration_number || "",
            insurance_policy_number: therapistDetails?.therapist_detail?.insurance_policy_number || "",
            assigned_client_category: therapistDetails?.therapist_detail?.assigned_client_category?.split(",")?.filter(Boolean).map(item => CLIENT_TYPES?.find(x => x.value == item)),
            calendly_link: therapistDetails?.therapist_detail?.calendly_link,
            self_description: therapistDetails?.therapist_detail?.self_description || "",
            profile_picture: therapistDetails?.therapist_detail?.profile_picture || "",
            email_signature: therapistDetails?.therapist_detail?.email_signature || "",
            signature_img: therapistDetails?.therapist_detail?.signature_img || "",
            status: therapistDetails?.status,
            documents: therapistDetails?.clientResources?.map(({ attachment_key, attachment_name, id }) => ({ attachment_key, attachment_name, id })) || [],
            timezone: { label: therapistDetails?.therapist_detail?.timezone, value: therapistDetails?.therapist_detail?.timezone },
            emergency_email: therapistDetails?.therapist_detail?.emergency_email || "",
            emergency_firstname: therapistDetails?.therapist_detail?.emergency_firstname || "",
            emergency_lastname: therapistDetails?.therapist_detail?.emergency_lastname || "",
            emergency_phone: therapistDetails?.therapist_detail?.emergency_phone || "",
            emergency_relationship: therapistDetails?.therapist_detail?.emergency_relationship || ""
        }
    }, [therapistDetails]);

    const handleSubmit = async (payload) => {
        try {
            if (usernameError) {
                errorMessageToast(usernameError);
                return;
            };

            const values = cloneDeep(payload);
            values.insurance_policy_number = values.insurance_policy_number || "";
            values.registration_number = values.registration_number || "";
            values.timezone = values.timezone.value
            values.therapistDocuments = {
                business_license: values.therapistDocuments?.business_license || "",
                college_registration: values.therapistDocuments?.college_registration || "",
                policy_check: values.therapistDocuments?.policy_check || "",
                professional_liability_insurance: values.therapistDocuments?.professional_liability_insurance || "",
                professional_liabilities_insurances: values.therapistDocuments?.professional_liabilities_insurances?.map((item) => ({
                    file: item?.file || "",
                    label: item?.label || ""
                }))
            }

            delete values.assigned_client_category;
            delete values.designation_id;
            delete values.discipline_id;
            // delete values.email;
            delete values.status;
            delete values.type;

            const result = await updateProfile(values);
            if (result.error) return;

            successMessageToast(result?.data?.message);

        } catch (err) { console.log("Error updating profile", err); }
    };

    const handleUsernameChange = useCallback(debounce(async (value, setFieldError) => {
        try {
            if (value) {
                const response = await checkUsername({ username: value });
                if (response?.data?.data?.status == "false") {
                    setFieldError("username", "Username already exist")
                    setUsernameError("Username already exist");
                    return;
                };
                setFieldError("username", "")
                setUsernameError(null);
            };
        } catch (err) { console.log("Error checking username", err) };
    }, [500]));

    const handleAttachDocument = (name, value, prevValues = [], setFieldValue) => {
        try {
            let cloneValues = cloneDeep(prevValues);
            cloneValues.push({
                attachment_key: value,
                attachment_name: value,
            })
            setFieldValue(name, cloneValues);
        } catch (err) {
            console.error("Failed to attach document", err);
        }
    };

    const handleViewPdf = async (name) => {
        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };


    return (
        <>
            <div className="px-3 py-2">
                <Breadcrumbs items={[{ label: "Profile", path: "/profile" }, { label: "User Information", path: "" }]} style={{ fontSize: "14px" }} />

                <UpdateEmailPop
                    confirmation={showEmailModal}
                    setConfirmation={setShowEmailModal}
                />
                <section className={`${styles.addForm} position-relative col-lg-10 addForm`}>
                    <Container fluid={true}>
                        {(therapistDetailsLoading) ? <LoadingIndicator /> : <Row>
                            {(therapistDetailsFetching || getFileFetching) && <LoadingOverlay />}

                            <Col lg="12" className="my-2 px-0 ">
                                {therapistDetailsError ? (
                                    <ErrorComponent />
                                ) : (
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={profileSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {({
                                            handleSubmit,
                                            errors,
                                            submitCount,
                                            values,
                                            setFieldValue,
                                            setFieldError
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <div
                                                >
                                                    {console.log('FORMIK VALUES', values)}

                                                    <Col lg="12" className="my-2">
                                                        <div style={{ borderBottom: '0.75px solid #93278F', paddingBottom: "11px" }} className=' d-flex align-items-end justify-content-between'>
                                                            <h5 className='section-title-main fw-medium border-0 m-0 p-0'>User Information</h5>
                                                            <button className="discharge-screen">{updateProfileLoading ? <LoadingIndicator color="#fff" /> : 'Save Changes'}  </button>
                                                        </div>
                                                        <h5 style={{ marginTop: "16px" }} className="section-title">KCS INFORMATION</h5>
                                                    </Col>
                                                    <Row>
                                                        <Col lg='4'>
                                                            <label className="discharge-screen-label">Discipline</label><br />
                                                            <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{values?.discipline_id?.label}</p>
                                                        </Col>
                                                        <Col lg='4'>
                                                            <label className="discharge-screen-label">Type</label><br />
                                                            <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{values?.type}</p>
                                                        </Col>
                                                        <Col lg='4'>
                                                            <label className="discharge-screen-label">Client Category</label><br />
                                                            {
                                                                values?.assigned_client_category?.map((item) => (
                                                                    <div className="d-flex align-items-center gap-1">
                                                                        <img width={12} height={9} src={rightCheckBlue} alt="rightCheckBlue" />
                                                                        <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{item?.label}</p>
                                                                    </div>
                                                                ))
                                                            }

                                                        </Col>
                                                    </Row>

                                                    <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">PROFILE INFORMATION</h5>
                                                        <div className="d-flex flex-column gap-4 pe-md-4">
                                                            <Row>
                                                                <Col md="5" className="d-flex gap-4">
                                                                    <div>
                                                                        <label className="discharge-screen-label">Last Name*</label>
                                                                        <AppInputFieldV2
                                                                            name="lastname"
                                                                            type="text"
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="discharge-screen-label">First Name*</label>
                                                                        <AppInputFieldV2
                                                                            name="firstname"
                                                                            type="text"
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <label className="discharge-screen-label">Email*</label>
                                                                    <AppInputFieldV2
                                                                        name="email"
                                                                        type="email"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                                <Col md="3">
                                                                    <label className="discharge-screen-label">Phone Number*</label>
                                                                    <AppInputFieldV2
                                                                        name="phone"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>

                                                            </Row>
                                                            <Row>
                                                                <Col md="5">
                                                                    <label className="discharge-screen-label">Address Line 1</label>
                                                                    <AppInputFieldV2
                                                                        name="address1"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="5">
                                                                    <label className="discharge-screen-label">Address Line 2</label>
                                                                    <AppInputFieldV2
                                                                        name="address2"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                                <Col md="4">
                                                                    <label className="discharge-screen-label">City</label>
                                                                    <AppInputFieldV2
                                                                        name="city"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                                <Col md="3">
                                                                    <label className="discharge-screen-label">Postal Code</label>
                                                                    <AppInputFieldV2
                                                                        name="postal_code"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        {/* <div style={{ marginTop: "20px" }} className="d-flex align-items-center gap-3">
                                                            <div style={{ width: "48%" }}>
                                                                <label className="discharge-screen-label">Address Line 2</label>
                                                                <AppInputFieldV2
                                                                    name="address2"
                                                                    type="text"
                                                                    placeholder=""
                                                                    className={`readonly-box`}
                                                                />
                                                            </div>
                                                            <div style={{ width: "23%" }}>
                                                                <label className="discharge-screen-label">City*</label>
                                                                <AppInputFieldV2
                                                                    name="city"
                                                                    type="text"
                                                                    placeholder=""
                                                                    className={`readonly-box`}
                                                                />
                                                            </div>
                                                            <div style={{ width: "31%" }}>
                                                                <label className="discharge-screen-label">Postal Code*</label>
                                                                <AppInputFieldV2
                                                                    name="postal_code"
                                                                    type="text"
                                                                    placeholder=""
                                                                    className={`readonly-box`}
                                                                />
                                                            </div>
                                                        </div> */}
                                                    </div>

                                                    <div style={{ marginTop: "44px" }}>
                                                        <h5 className="profile-title">EMERGENCY CONTACT INFORMATION</h5>
                                                        <div className="d-flex flex-column gap-4">
                                                            <Row>
                                                                <Col md="6" className='d-flex gap-4'>
                                                                    <TextInputV2
                                                                        required
                                                                        name="emergency_lastname"
                                                                        label='Last Name'
                                                                        value={values?.emergency_lastname}
                                                                        onChange={(e) => setFieldValue("emergency_lastname", e.target.value)}
                                                                    />
                                                                    <TextInputV2
                                                                        required
                                                                        name="emergency_firstname"
                                                                        label='First Name'
                                                                        value={values?.emergency_firstname}
                                                                        onChange={(e) => setFieldValue("emergency_firstname", e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col md="3">
                                                                    <TextInputV2
                                                                        required
                                                                        name="emergency_email"
                                                                        label='Email' type='email'
                                                                        value={values?.emergency_email}
                                                                    // disabled
                                                                    />
                                                                </Col>
                                                                <Col md="3">
                                                                    <TextInputV2
                                                                        required
                                                                        name="emergency_phone"
                                                                        label='Phone Number'
                                                                        type='number'
                                                                        value={values?.emergency_phone}
                                                                        onChange={(e) => setFieldValue("emergency_phone", e.target.value)}

                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="4">
                                                                    <TextInputV2
                                                                        name="emergency_relationship"
                                                                        label='Relationship to Clinician'
                                                                        value={values?.emergency_relationship}
                                                                        onChange={(e) => setFieldValue("emergency_relationship", e.target.value)}

                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </div>

                                                    <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">DOCUMENTS</h5>
                                                        <div className="d-flex flex-column gap-4 pe-md-4">
                                                            <UserDocuments setFieldValue={setFieldValue} values={values} />
                                                        </div>

                                                    </div>

                                                    <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">SIGNATURE</h5>
                                                        <Row className="pe-md-4">
                                                            <Col lg='4'>
                                                                <p style={{ fontStyle: "italic", fontSize: "14px", color: "rgb(7, 30, 62);" }}>Your signature will appear at the end of all reports. It should include details like: your full name, accreditation, title, and contact (email).*</p>
                                                            </Col>
                                                            <Col lg='8'>
                                                                <div className="mb-4">
                                                                    <div className="ck-editor-wrapper">
                                                                        <CustomEditor name={`email_signature`} />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <p style={{ fontStyle: "italic", fontSize: "14px", color: "rgb(7, 30, 62);" }}>Signature Image File</p>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <div className="d-flex align-items-end gap-2">
                                                                    <FilePicker
                                                                        value={values.signature_img}
                                                                        onChange={(fileUrl) => {
                                                                            setFieldValue("signature_img", fileUrl)
                                                                        }}
                                                                    />
                                                                </div>
                                                                {errors?.signature_img && (
                                                                    <div className="text-danger small mt-1">{errors?.signature_img}</div>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                    <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">PROFILE IMAGE</h5>
                                                        <Row className="pe-md-4">
                                                            <Col lg='4'>
                                                                <p style={{ fontStyle: "italic", fontSize: "14px", color: "rgb(7, 30, 62);" }}>Profile Image File</p>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <FilePicker
                                                                    value={values?.profile_picture}
                                                                    onChange={(fileUrl) => setFieldValue("profile_picture", fileUrl)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                                {(!isEmpty(errors) && submitCount > 0) && (
                                                    <Row className="mt-4">
                                                        <Col lg="12">
                                                            <span className="error">{genericFormErrorMsg}</span>
                                                        </Col>
                                                    </Row>
                                                )}
                                                {/* <Row className="mt-4">
                                                <Col className="my-2" lg="12">
                                                    <div
                                                        className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                        style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <LoadingButton
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center commonBtn"
                                                            isLoading={updateProfileLoading}
                                                        >
                                                            Save
                                                        </LoadingButton>
                                                    </div>
                                                </Col>
                                            </Row> */}
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                            </Col>








                            {/* <Col lg="12" className="my-2">
                            {therapistDetailsError ? (
                                <ErrorComponent />
                            ) : (
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={profileSchema}
                                    onSubmit={handleSubmit}
                                    enableReinitialize
                                >
                                    {({
                                        handleSubmit,
                                        errors,
                                        submitCount,
                                        values,
                                        setFieldValue,
                                        setFieldError
                                    }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <div
                                                className="py-3"
                                                style={{ borderTop: "1px solid #41a2a84d" }}
                                            >
                                                {console.log('FORMIK VALUES', values)}
                                                <Row>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Profile Picture
                                                        </label>
                                                        <AppProfilePictureField
                                                            name="profile_picture"
                                                            acl={"public-read"}
                                                            accept="image/*"
                                                            allowedTypes={[MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.png]}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Last Name
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="lastname"
                                                            placeholder="e.g Smith"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            First Name
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="firstname"
                                                            placeholder="e.g John"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Username
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <div className="d-flex w-100 position-relative flex-column">
                                                            <AppInputField
                                                                name="username"
                                                                type="text"
                                                                placeholder="Enter Username"
                                                                className={`${styles.formControl} form-control`}
                                                                onInputChange={(value) => handleUsernameChange(value, setFieldError)}
                                                                maxLength={100}
                                                            />
                                                            {checkUsernameLoading && <div style={{ right: "10px", top: "20px" }} className="position-absolute">
                                                                <LoadingIndicator inline />
                                                            </div>}
                                                        </div>
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Email
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="email"
                                                            type="text"
                                                            placeholder="Enter Email"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Phone Number
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="phone"
                                                            placeholder="e.g +1 234567890"
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={25}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Discipline
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <CommonSelect
                                                            name="discipline_id"
                                                            placeholder={"Select Discipline"}
                                                            option={[]}
                                                            isDisabled
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Designation
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <CommonSelect
                                                            name="designation_id"
                                                            option={[]}
                                                            isDisabled
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Therapist Type
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppSelectField
                                                            disabled
                                                            label="Choose type"
                                                            name="type"
                                                            options={[
                                                                { value: "veteran", label: "Veteran" },
                                                                { value: "apprentice", label: "Apprentice" },
                                                            ]}
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Registration Number
                                                        </label>
                                                        <AppInputField
                                                            name="registration_number"
                                                            placeholder="Enter register number"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Insurance Policy number
                                                        </label>
                                                        <AppInputField
                                                            name="insurance_policy_number"
                                                            placeholder="Enter Insurance Policy number"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="3" md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Assigned Client Categories
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <CommonMultiSelect
                                                            isDisabled
                                                            placeholder="Select Category"
                                                            name="assigned_client_category"
                                                            option={CLIENT_TYPES}
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Calendly link
                                                        </label>
                                                        <AppInputField
                                                            name="calendly_link"
                                                            placeholder="Enter Calendly link here "
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            About{" "}
                                                            <p className="text-muted fw-normal inline-block ms-1 m-0">
                                                                (Description)
                                                            </p>
                                                        </label>
                                                        <AppInputField
                                                            name="self_description"
                                                            placeholder="Add Bio"
                                                            fieldType="textarea"
                                                            rows="4"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col lg="12" className="my-2">
                                                        <Row>
                                                            <Col md="6" sm="6" className="my-2">
                                                                <label
                                                                    htmlFor=""
                                                                    className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                >
                                                                    Upload Documents
                                                                </label>
                                                                <AppFileUploadField
                                                                    name="documents"
                                                                    acl={"private"}
                                                                    accept="image/*, application/pdf, .doc, .docx"
                                                                    allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                                                                    className={`${styles.formControl} form-control`}
                                                                    onChange={(name, value) => {
                                                                        handleAttachDocument(name, value, values?.documents, setFieldValue);
                                                                    }}

                                                                />
                                                                {
                                                                    values?.documents?.length > 0 &&
                                                                    <ViewAttachments
                                                                        attachments={values?.documents}
                                                                        handleViewPdf={handleViewPdf}
                                                                    />
                                                                }
                                                            </Col>
                                                            <Col md="6" sm="6" className="my-2">
                                                                <Row>
                                                                    <Col md="12" sm="12" className="mb-2">
                                                                        <label
                                                                            htmlFor=""
                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                        >
                                                                            Timezone
                                                                            <RequiredFieldAstrick />
                                                                        </label>
                                                                        <CommonSelect
                                                                            name="timezone"
                                                                            option={TIMEZONE_OPTIONS}
                                                                        />
                                                                    </Col>
                                                                    <Col md="12" sm="12" className="mb-2">
                                                                        <label
                                                                            htmlFor=""
                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                        >
                                                                            Signature
                                                                        </label>
                                                                        <AppInputField
                                                                            fieldType="textarea"
                                                                            name="email_signature"
                                                                            rows={4}
                                                                            cols={4}
                                                                            placeholder="John Doe&#10;john@example.com&#10;+1 222 222 2222&#10;Street 10, NY, USA "
                                                                            className={`${styles.formControl} form-control`}
                                                                            maxLength={500}
                                                                            style={{ height: "95px" }}
                                                                        />
                                                                    </Col>
                                                                    <Col md="12" sm="12" className="my-2">
                                                                        <label
                                                                            htmlFor=""
                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                        >
                                                                            Upload Signature
                                                                        </label>
                                                                        <AppFileUploadField
                                                                            name="signature_img"
                                                                            acl={"public-read"}
                                                                            allowedTypes={[MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg]}
                                                                            className={`${styles.formControl} form-control`}
                                                                            isMulti={false}
                                                                            preview
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>
                                            {(!isEmpty(errors) && submitCount > 0) && (
                                                <Row className="mt-4">
                                                    <Col lg="12">
                                                        <span className="error">{genericFormErrorMsg}</span>
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row className="mt-4">
                                                <Col className="my-2" lg="12">
                                                    <div
                                                        className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                        style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <LoadingButton
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center commonBtn"
                                                            isLoading={updateProfileLoading}
                                                        >
                                                            Save
                                                        </LoadingButton>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </Col> */}
                        </Row>}
                    </Container>
                </section>
            </div>
        </>
    );
};

export default UserInformation;